import type {
  VisibilityDecision,
  VisibilityDenialReason,
} from '~/types/visibility'

type DeniedVisibilityDecision = Extract<VisibilityDecision, { visible: false }>

const ACCESS_REASONS: VisibilityDenialReason[] = ['access-level', 'group']
const REGION_REASONS: VisibilityDenialReason[] = ['country', 'language']

export const shouldRedirectToUnauthorized = (
  decision: DeniedVisibilityDecision,
) => decision.reasons.length === 1 && decision.reasons.includes('not-logged-in')

/**
 * Resolves the static unauthorized page a denied decision routes to, or `null`
 * to fall back to the regular access-denial redirect. Access reasons take
 * precedence over region reasons.
 */
export const resolveUnauthorizedPath = (
  decision: DeniedVisibilityDecision,
): string | null => {
  if (shouldRedirectToUnauthorized(decision)) return '/unauthorized'

  const reasons = decision.reasons
  const hasAny = (allowed: VisibilityDenialReason[]) =>
    reasons.some((reason) => allowed.includes(reason))

  if (hasAny(ACCESS_REASONS)) return '/unauthorized-access'
  if (hasAny(REGION_REASONS)) return '/unauthorized-region'

  return null
}
